module.exports = __webpack_public_path__ + "static/image/history/m/202010_2@3x.jpg?8ab1e085";